const TZ = "Asia/Seoul";

export function utcDate(input: string | Date): Date {
  if (input instanceof Date) return new Date(input.getTime());
  const s = String(input).trim();
  if (!s) return new Date(NaN);
  if (/[zZ]$|[+-]\d{2}:?\d{2}$/.test(s)) return new Date(s);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return new Date(`${s}T00:00:00.000Z`);
  return new Date(`${s}Z`);
}

/** KST 표시(관리자 목록·엑셀 주문일자 공통) */
export function formatKst(input: string | Date): string {
  const d = utcDate(input);
  if (Number.isNaN(d.getTime())) return String(input);
  return new Intl.DateTimeFormat("ko-KR", {
    timeZone: TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(d);
}
